export default {
  create: (client, params) => client.$post(`newsletter_subscribers`, params),
  updatePreferences: (client, params) => client.$patch(`newsletter_subscribers/update_preferences`, params),
}